import { Injectable } from '@angular/core';
import { GrupoParada } from '@tivic-team/manager-ts/dist/mob/entities/parada/grupo-parada.entity';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { GrupoParadaDTO } from '../../model/dtos/mob/grupoParada.dto';

@Injectable()
export class GrupoParadaController {

    constructor() { }
    
    async getAllPracaTaxi():Promise<Array<GrupoParada>>{
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/gruposparadas/pontostaxi',
					environment: environment
				}),
			}),
			new HttpResponse(
				new Array<GrupoParada>()
			)
		);
		return await quark.call();
	}

	async create(grupoParada: GrupoParada): Promise<GrupoParada>{
        let quark = new Quark(
            new HttpPost({
                url: new Url({
                    id: 'mob/gruposparadas',
                    environment: environment
                }),

                data: new JSONData(grupoParada)
            }),

            new HttpResponse(
                new GrupoParada()
            )
        );

        return await quark.call();
    }

    async findPontostaxi(filtros?: IFilter): Promise<Array<GrupoParada>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/gruposparadas/pontostaxi',
                    environment: environment,
                    filter: filtros
                }),
            }),

            new HttpResponse(
                new Array<GrupoParada>()
            )
        );

        return await quark.call();
    }

    async getPontostaxi (cdGrupoParada: number): Promise<GrupoParada>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/gruposparadas/pontostaxi/:cdGrupoParada',
                    environment: environment,
                    pathParams: new JSONData({ cdGrupoParada: cdGrupoParada})
                }),
            }),
            new HttpResponse(
                new GrupoParada()
            )
        );

        return await quark.call();
    }

    async updatePontostaxi(grupoParada: GrupoParada): Promise<GrupoParada>{
        let quark = new Quark(
            new HttpPut({
                url: new Url({
                    id: 'mob/gruposparadas/pontostaxi/:cdGrupoParada',
                    environment: environment,
                    pathParams: new JSONData({ cdGrupoParada: grupoParada.cdGrupoParada})
            }),

            data: new JSONData(grupoParada)
            }),
            new HttpResponse(
                new GrupoParada()
            )
        );

        return await quark.call();
    }

    async find(filtros?: IFilter): Promise<Array<GrupoParadaDTO>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/gruposparadas',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<GrupoParadaDTO>()
			)
		);
		return await quark.call();
	}

	async get(cdGrupoParada: number): Promise<GrupoParadaDTO> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/gruposparadas/:cdGrupoParada',
					environment: environment,
					pathParams: new JSONData({ cdGrupoParada })
				}),
			}),
			new HttpResponse(
				new GrupoParadaDTO()
			)
		);
		return await quark.call();
	}
}